$views.mailboxsettings = {

  display : function($fromHelp) {

    // if some features are disabled in the config, then force them to be display:none
    if (!$config.mailbox.userEditableSyncActive) {
      jQuery('#user-profile-sync-active').hide();
    }
    if (!$config.mailbox.userEditableConnectionSettings) {
      jQuery('#user-profile-sync-basic *').hide();
    }
    if (!$config.mailbox.userEditableNumberOfDays) {
      jQuery('#user-profile-sync-settings-number-days').hide();
    }
    if (!$config.mailbox.userEditableSyncFolders) {
      jQuery('#user-profile-sync-settings-which-folders').hide();
    }
    if (!$config.mailbox.userEditableNumberOfDays && !$config.mailbox.userEditableSyncFolders) {
      jQuery('#user-profile-sync-settings *').hide();
    }

    // load data for the form
    $models.users.getMyData(function($data) {


      // pre-populate port number under Advanced
      if (!$data.user.port || ($data.user.port == '')) {
        if ($data.user.ui_remote_access_type == 'imap') {
          jQuery('#profile-form #port').val('993');
        } else {
          jQuery('#profile-form #port').val('443');
        }
      }

      // pre-populate host name under Advanced
      if (!$data.user.host || ($data.user.host == '')) {
        $data.user.host = 'mail.' + $data.user.email.split('@')[1];
      }

      // pre-populate email address in Basic and username in Advanced
      if (!$data.user.remote_username || ($data.user.remote_username == '')) {
        $data.user.remote_username = $data.user.email;
      }
      $data.user.remote_email = $data.user.remote_username;

      // mailbox type dropdown: options

      var $mailboxOptions = [
        {
          text: "Exchange",
          value: 'exchange',
          selected: false,
          description: "Connect to Exchange account",
          imageSrc: $soupmail.images["mailbox-exchange.png"]
        },
        {
          text: "Gmail - Legacy",
          value: 'gmail',
          selected: false,
          description: "Connect to Gmail account via legacy username/password method",
          imageSrc: $soupmail.images["mailbox-gmail.png"]
        },
        {
          text: "IMAP",
          value: 'imap',
          selected: false,
          description: "Connect to IMAP account",
          imageSrc: $soupmail.images["mailbox-imap.png"]
        },
        {
          text: "Office 365",
          value: 'office365_oauth',
          selected: false,
          description: "Connect using Office 365",
          imageSrc: $soupmail.images["mailbox-office365.png"]
        }
      ];

      // mailbox type dropdown: display
      jQuery('#mailbox_selector').ddslick({
        data: $mailboxOptions,
        width: 312,
        imagePosition: "left",
        selectText: "Select your Mailbox Type:",
        onSelected: function (data) {
          $views.mailboxsettings.updateMailboxSelector(data.selectedData.value);
          if (data.selectedData.value == 'imap' || data.selectedDate == 'google_imap_oauth') {
            jQuery('#advanced').show();
          } else {
            jQuery('#advanced').hide();
          }
        },
        defaultSelectedIndex: $views.mailboxsettings.accessTypeTranslator($data.user.ui_remote_access_type)
      });

      // set the values of each of the form fields based on the existing profile data
      jQuery.each($data.user, function($key, $value) {
        if ($value === false) { $value = 'false'; }
        if ($value === true) { $value = 'true'; }
        if (($value != null) && ($value !== '')) {
          jQuery('#profile-form #'+$key).val($value);
        }
      });

      // show or hide the sync form as appropriate
      if ($data.user.sync_enabled){
        $views.mailboxsettings.showSyncFormReadOnly();
      }else{
        $views.mailboxsettings.hideSyncForm();
        if ($fromHelp === true){
          jQuery('#profile-form #sync_enabled').val('true');
          $views.mailboxsettings.showSyncFormBasic();
        }
      }
    });
  },

  toggleSyncForm : function() {

    // init variables
    $sync_enabled = (jQuery('#profile-form #sync_enabled').val() == 'true');

    // if this feature is disabled, then don't do anything
    if (!$config.mailbox.userEditableSyncActive) {
      return false;
    }

    // if this feature is enabled, but the editable connection settings is disabled, this function needs to work a bit differently!!
    if ($config.mailbox.userEditableSyncActive && !$config.mailbox.userEditableConnectionSettings) {

      if ($sync_enabled) {
        jQuery('#user-profile-sync-settings').show();
        $controllers.mailboxsettings.enableSync(); // save sync enabled, INSTANTLY
        $models.login.cachedMyUserDetails.user.sync_enabled = true;
      } else {
        jQuery('#user-profile-sync-settings').hide();
        $controllers.mailboxsettings.disableSync(); // save sync disabled
        $models.login.cachedMyUserDetails.user.sync_enabled = false;
      }

    } else {

      // Everytime sync is enabled you must enter your connection details: this verifies we have maximum valid connections saved
      if ($sync_enabled){
        $views.mailboxsettings.showSyncFormBasic(); // show basic connection settings
      } else {
        $views.mailboxsettings.hideSyncForm(); // hide sync settings & mailbox connection details
        $controllers.mailboxsettings.disableSync(); // save sync disabled
        // if help is open tick connect mailbox
        if (jQuery('#help').css('display') == 'block') {
          jQuery('#help .connect-mailbox').removeClass('done');
        }
        $models.login.cachedMyUserDetails.user.sync_enabled = false;
      }

    }
  },

  hideSyncForm : function() {
    console.log('hideSyncForm');
    jQuery('#user-profile-sync-basic, #advanced, #user-profile-sync-settings, #user-profile-ews, #user-profile-imap-prefix').hide();
  },

  showSyncFormBasic : function() {
    console.log('showSyncFormBasic');
    jQuery('#user-profile-sync-basic, #mailbox_sync_email, #mailbox_selector, #mailbox_sync_password, #mailbox_oauth2_button, #button-connect').show();
    jQuery('#advanced, #advanced #user-profile-advanced, #user-profile-sync-settings, #button-edit, .connection-status').hide();
    jQuery('#user-profile-sync-basic h2.title').text('Mailbox Connection Details');
    jQuery('#user-profile-sync-basic h2.title').removeClass('connected');
    if ($views.mailboxsettings.accessTypeTranslator(jQuery('#ui_remote_access_type').val()) == 'exchange') {
      // Set Mailbox Selector to Exchange
      $('#mailbox_selector').ddslick('select', {index: 0 });
      $views.mailboxsettings.updateMailboxSelector('exchange');
      jQuery('#advanced').show();
    } else if ($views.mailboxsettings.accessTypeTranslator(jQuery('#ui_remote_access_type').val()) == 'office365_oauth') {
      // Set Mailbox Selector to Office365
      $('#mailbox_selector').ddslick('select', {index: 3 });
      $views.mailboxsettings.updateMailboxSelector('office365_oauth');
      jQuery('#advanced').hide();
    }
    else {
      // Set Mailbox Selector to IMAP
      $('#mailbox_selector').ddslick('select', {index: 2 });
      $views.mailboxsettings.updateMailboxSelector('imap');
      jQuery('#advanced').show();
    }
    jQuery('#user-profile-sync-basic input, #user-profile-sync-basic select').removeAttr('readonly').removeClass('readonly');
  },

  showSyncFormAdvanced : function($delay) {
    console.log('showSyncFormAdvanced');
    jQuery('#user-profile-sync-basic, #mailbox_selector, #user-profile-sync-settings, #advanced, #mailbox_sync_password, #mailbox_oauth2_button, #button-connect').show();
    jQuery('#mailbox_sync_email, #button-edit, #advanced #user-profile-advanced').hide();
    jQuery('#user-profile-sync-basic h2.title').text('Mailbox Connection Details');
    jQuery('#user-profile-sync-basic h2.title').removeClass('connected');
    if ($delay && ($delay > 0)) {
      setTimeout(function() {
        jQuery('#advanced #user-profile-advanced').slideDown('slow');
      }, $delay);
    } else {
      jQuery('#advanced #user-profile-advanced').show();
    }
    $views.mailboxsettings.updateMailboxSelector(jQuery('#ui_remote_access_type').val());
    jQuery('#user-profile-sync-basic input.text').removeAttr('readonly').removeClass('readonly');
    jQuery('#user-profile-sync-basic #ssl').removeAttr('disabled');
  },

  showSyncFormReadOnly : function() {
    console.log('showSyncFormReadOnly');
    console.log($views.mailboxsettings.accessTypeTranslator(jQuery('#ui_remote_access_type').val()));

    jQuery('#user-profile-sync-basic, #user-profile-sync-settings, #advanced, #button-edit').show();
    jQuery('#mailbox_selector, #mailbox_sync_password, #button-connect, #edit-cancel, #mailbox_sync_email, #advanced #user-profile-advanced').hide();

    // Show Connected Using 'Type'
    jQuery('#connection_type').html($views.mailboxsettings.displayAccessTypeTranslator(jQuery('#ui_remote_access_type').val()));

    if ($views.mailboxsettings.accessTypeTranslator(jQuery('#ui_remote_access_type').val()) == 'exchange') {
      $views.mailboxsettings.updateMailboxSelector('exchange');
      jQuery('.connection-status#connected .imap-image').hide();
      jQuery('.connection-status#connected .office365-image').hide();
      jQuery('.connection-status#connected .exchange-image').show();
      jQuery("#advanced").show();
    }
    else if ($views.mailboxsettings.accessTypeTranslator(jQuery('#ui_remote_access_type').val()) == 'google_imap_oauth') {
      $views.mailboxsettings.updateMailboxSelector('google_imap_oauth');
      jQuery('.connection-status#connected .exchange-image').hide();
      jQuery('.connection-status#connected .office365-image').hide();
      jQuery('.connection-status#connected .imap-image').show();
      jQuery("#advanced").hide();

    }
    else if ($views.mailboxsettings.accessTypeTranslator(jQuery('#ui_remote_access_type').val()) == 'office365_oauth') {
      $views.mailboxsettings.updateMailboxSelector('office365_oauth');
      jQuery('.connection-status#connected .exchange-image').hide();
      jQuery('.connection-status#connected .office365-image').show();
      jQuery('.connection-status#connected .imap-image').hide();
      jQuery("#advanced").hide();
      jQuery('li#mailbox_sync_email').show();
      jQuery('li#mailbox_sync_email .label').html('Connected to:');

    }
    else  {
      $views.mailboxsettings.updateMailboxSelector('imap');
      jQuery('.connection-status#connected .exchange-image').hide();
      jQuery('.connection-status#connected .office365-image').hide();
      jQuery('.connection-status#connected .imap-image').show();
      jQuery("#advanced").show();
    }
    jQuery("#mailbox_oauth2_button").hide();
    jQuery('#user-profile-sync-basic h2.title').text('Mailbox Connected');
    jQuery('#user-profile-sync-basic h2.title').addClass('connected');
    jQuery('#user-profile-sync-basic input.text').attr('readonly', 'readonly').addClass('readonly');
    jQuery('#user-profile-sync-basic #ssl').attr('disabled','disabled');
    jQuery('#button-google-imap-oauth2-connect').hide();
    jQuery('.connection-status#connected').show();
  },

  updateMailboxSelector : function($value) {
    jQuery('#ui_remote_access_type').val($value);
    jQuery('li#mailbox_sync_email .label').html('Email:');
    if ($value == 'exchange') {
      jQuery('#user-profile-ews').show();
      jQuery('#user-profile-imap-prefix').hide();
      jQuery('li#mailbox_sync_email').show();
      jQuery('li#mailbox_sync_password').show();
      jQuery('li#mailbox_oauth2_button').hide();
      jQuery('input#button-connect').show();
      jQuery('input#button-connect-oauth').hide();
      jQuery('#button-google-imap-oauth2-connect').hide();
    }
    else if ($value == 'google_imap_oauth') {
      jQuery('#user-profile-ews').hide();
      jQuery('#user-profile-imap-prefix').hide();
      jQuery('li#mailbox_sync_email').hide();
      jQuery('li#mailbox_sync_password').hide();
      jQuery('li#mailbox_oauth2_button').show();
      jQuery('input#button-connect').hide();
      jQuery('input#button-connect-oauth').hide();
      jQuery('#button-google-imap-oauth2-connect').show();
    }
    else if ($value == 'office365_oauth') {
      jQuery('#user-profile-ews').hide();
      jQuery('#user-profile-imap-prefix').hide();
      jQuery('li#mailbox_sync_email').hide();
      jQuery('li#mailbox_sync_password').hide();
      jQuery('input#button-connect').hide();
      jQuery('input#button-connect-oauth').show();
      jQuery('li#mailbox_oauth2_button').hide();
      jQuery('#button-google-imap-oauth2-connect').hide();
    }
    else { //imap
      jQuery('#user-profile-ews').hide();
      jQuery('#user-profile-imap-prefix').show();
      jQuery('li#mailbox_sync_email').show();
      jQuery('li#mailbox_sync_password').show();
      jQuery('li#mailbox_oauth2_button').hide();
      jQuery('input#button-connect').show();
      jQuery('input#button-connect-oauth').hide();
      jQuery('#button-google-imap-oauth2-connect').hide();
    }
  },

  accessTypeTranslator : function($value) {
    if ($value == 'ews') { return 'exchange'; }
    if ($value == 'google_imap_oauth') { return 'google_imap_oauth'; }
    if ($value == 'office365_oauth') { return 'office365_oauth'; }
    if ($value == 'imap') { return 'imap'; }
    return 'exchange';
  },

  displayAccessTypeTranslator : function($value) {
    if ($value == 'ews') { return 'Exchange'; }
    if ($value == 'google_imap_oauth') { return 'GOOGLE_IMAP_OAUTH'; }
    if ($value == 'office365_oauth') { return 'Office 365'; }
    if ($value == 'imap') { return 'IMAP'; }
    return 'Exchange';
  },

  googleConnectionBtn: function() {
    window.open('http://localhost:3000/auth/google_oauth2?popup=true&user_id='+$models.login.getUserid(),'Sign In','width=600,height=800')
  },

  office365ConnectionBtn: function() {
    window.open($config.api_protocol + $config.api_hostname + '/auth/office365?user_id='+$models.login.getUserid(),'Sign In','width=600,height=800')
  },

  testGoogleConnectionBtn: function() {
    $models.all.getDataFromAPI('test_connection.json', {}, function($data) {
      if ($data.connected) {
        $soupmail.notification.message('Mailbox Successfully Connected')
      } else {
        $soupmail.notification.error('Could not connect to the remote mailbox using your existing settings. Please try re-authorising application using "Connect with Google" button.')
      }
    }, function($error) {
      //Do Nothing
    }, 'POST');
  },

  testOffice365ConnectionBtn: function() {
    $models.all.getDataFromAPI('test_connection.json', {}, function($data) {
      if ($data.connected) {
        $soupmail.notification.message('Mailbox Successfully Connected')
      } else {
        $soupmail.notification.error('Could not connect to the remote mailbox using your existing settings. Please try re-authorising application using "Connect with Office 365" button.')
      }
    }, function($error) {
      //Do Nothing
    }, 'POST');
  }

};



// WEBPACK FOOTER //
// ./src/js/views/desktop.mailboxsettings.js